import React, { Component } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./subComponents/home";
import Header from "./subComponents/header";
import Footer from "./subComponents/footer";
import LaunchPad from "./subComponents/launchPad";
import Box from "./subComponents/box";
import UpcomingProjComp from "./subComponents/upcoming";
import { PregnantWoman } from "@material-ui/icons";
import PreviousProjComp from "./subComponents/previous";
import Staking from "./subComponents/asset";
import LP from "./subComponents/lp";

class MainAppBody extends Component {
  render() {
    return (
      <React.Fragment>
        <Router basename="">
          <Header />

          <Routes>
            <Route path="/" element={<Home />} exact />

            <Route path="/launchpad" element={<LaunchPad />} />

            <Route path="/box" element={<Box />} />

            <Route path="/upcoming-projects" element={<UpcomingProjComp />} />

            <Route path="/previous-projects" element={<PreviousProjComp />} />

            <Route path="/assets" element={<Staking />} />

            <Route path="/lp" element={<LP />} />

          </Routes>

          <Footer />
        </Router>
      </React.Fragment>
    );
  }
}

export default MainAppBody;
